<template>
  <div class="user-info-modal">
    <h2 class="lvl2-heading">
      {{ user.last_name }} {{ user.first_name }} -
      <span>{{ user.role_string }}</span>
    </h2>
    <div class="user-info-modal__table">
      <div class="user-info-modal__column">
        <tr>
          <th>Prénom:</th>
          <td>{{ user.first_name || "N/A" }}</td>
        </tr>
        <tr>
          <th>Nom:</th>
          <td>{{ user.last_name || "N/A" }}</td>
        </tr>
        <tr>
          <th>Société:</th>
          <td>{{ user.company || "N/A" }}</td>
        </tr>
        <!--
        <tr>
          <th v-if="user.role === 'pharmacist'">Adresse de votre pharmacie:</th>
          <th v-else>Adresse:</th>
          <td>{{ user.address || "N/A" }}</td>
        </tr>
        -->
        <tr>
          <th>Code postal:</th>
          <td>{{ user.postcode || "N/A" }}</td>
        </tr>
        <tr>
          <th>Ville:</th>
          <td>{{ user.city || "N/A" }}</td>
        </tr>
      </div>

      <div class="user-info-modal__column">
        <tr v-if="user.role === 'pharmacist'">
          <th>Groupement:</th>
          <td>{{ user.group ? user.group : "Non renseigné" }}</td>
        </tr>
        <tr>
          <th>Adresse e-mail:</th>
          <td>{{ user.email || "N/A" }}</td>
        </tr>
        <!--
        <tr>
          <th>Numéro de téléphone fixe:</th>
          <td>{{ user.landline || "N/A" }}</td>
        </tr>
        <tr>
          <th>Numéro de téléphone portable:</th>
          <td>{{ user.phone || "N/A" }}</td>
        </tr>
        -->
        <tr v-if="user.role === 'pharmacist'">
          <th>Date de début d'activité:</th>
          <td>{{ user.activity_started_at || "N/A" }}</td>
        </tr>
        <tr v-if="user.role === 'pharmacist'">
          <th>Démarrage des plannings mensuels:</th>
          <td v-if="user.planning_cycle">
            Tous les {{ user.planning_cycle }} du mois
          </td>
          <td v-else>
            {{ user.plannings_start_day || "N/A" }}
          </td>
        </tr>
        <tr v-if="user.role === 'pharmacist'">
          <th>Longitude:</th>
          <td>{{ user.longitude || "N/A" }}</td>
        </tr>
        <tr v-if="user.role === 'pharmacist'">
          <th>Latitude:</th>
          <td>{{ user.latitude || "N/A" }}</td>
        </tr>
      </div>
    </div>

    <template v-if="supports.length">
      <h4 class="lvl4-heading">Supports</h4>
      <div class="user-info-modal__supports">
        <div
          v-for="supp in supports"
          :key="`supp-f__${supp.id}`"
          class="user-info-modal__supp"
        >
          <!-- <component
            class="user-info-modal__svg"
            :is="supp.component"
          ></component> -->
          <span>{{ supp.name }}</span>
          <span v-if="supp.format !== ''" class="user-info-modal__formats">
            -{{ supp.format }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getSupportsSVGs } from "@/utils"
export default {
  components: {
    ...getSupportsSVGs()
  },
  data() {
    return {
      user: null
    }
  },
  computed: {
    ...mapGetters(["modal"]),
    supports() {
      return this.user.supports.map(sup => ({
        ...sup,
        component: "support-" + sup.id
      }))
    }
  },
  created() {
    this.user = this.modal.payload.user
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";

.user-info-modal {
  $self: &;
  padding-top: 50px !important;
  width: 620px;
  &__table {
    text-align: left;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    #{$self}__column {
      width: 46%;
      tr,
      th,
      td {
        width: 100%;
        display: block;
      }

      tr {
        margin-bottom: 20px;
      }
      th {
        color: $color-neutral-3;
        color: var(--color-neutral-3, $color-neutral-3);
        margin-bottom: 11px;
        font-weight: normal;
      }
    }
  }

  &__supports {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
  }

  &__supp {
    background: $color-neutral-1;
    background: var(--color-neutral-1, $color-neutral-1);
    font-weight: 800;
    justify-content: center;
    color: $color-accent;
    color: var(--color-accent, $color-accent);
    fill: $color-neutral-4;
    fill: var(--color-accent, $color-accent);
    padding: 12px;
    margin-bottom: 12px;
    width: 48%;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    & > span {
      white-space: nowrap;
      text-overflow: ellipsis;
      margin: 0;
    }
  }

  &__svg {
    width: 30px;
    margin-right: 12px;
    height: auto;
  }

  &__formats {
    margin-top: 6px;
  }
}
</style>
